
import {initWebComponent} from "@/helpers/web-component-helper";
import {
    LayerInfoFilterSettingsApplyButtonComponent
} from "@/components/layer/info/filter/buttons/layer-info-filter-settings-apply-button-component";
import {
    LayerInfoFilterSettingsGeometryComponent
} from "@/components/layer/info/filter/settings/layer-info-filter-settings-geometry-component";
import {getActiveFilter, getActiveFilterFormAttributeByKey} from "@/helpers/filter/filter-helper";

export class LayerInfoFilterSettingsItemComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const formAttribute = getActiveFilterFormAttributeByKey(key)
        const attribute = formAttribute.attribute

        const template = document.createElement('template');
        let innerHTML = ``;

        if (attribute.Type === 21) {
            innerHTML += `<layer-info-filter-settings-geometry></layer-info-filter-settings-geometry>`
        } else {
            switch (formAttribute.AttributeTypeID) {
                // Alleen zichtbaar in resultaat
                case 1001:
                     break
                // Tekst uniek zoeken
                case 1010:
                    innerHTML += `<layer-info-filter-settings-text data-key="` + key + `"></layer-info-filter-settings-text>`
                    break;
                // Numeriek uniek zoeken
                case 1011:
                    innerHTML += `<layer-info-filter-settings-text data-key="` + key + `"></layer-info-filter-settings-text>`
                    break;
                // Numeriek tussen 2
                case 1013:
                    innerHTML += `<layer-info-filter-settings-numeric-between  data-key="` + key + `"></layer-info-filter-settings-numeric-between>`
                    break;
                // Deel van tekst zoeken
                case 1015:
                    innerHTML += `<layer-info-filter-settings-text data-key="` + key + `"></layer-info-filter-settings-text>`
                    break;
                // Lijst
                case 1022:
                    innerHTML += `<layer-info-filter-settings-list data-key="` + key + `"></layer-info-filter-settings-list>`
                    break;
                // Multi lijst
                case 1023:
                    innerHTML += `<layer-info-filter-settings-list-multi data-key="` + key + `"></layer-info-filter-settings-list-multi>`
                    break;
                // Datum tussen 2
                case 1030:
                    innerHTML += `<layer-info-filter-settings-date data-label="Tussen" data-label="" data-key="` + key + `"></layer-info-filter-settings-date>`
                    break;
                // Datum gelijk aan
                case 1031:
                    innerHTML += `<layer-info-filter-settings-date data-label="Datum" data-key="` + key + `"></layer-info-filter-settings-date>`
                    break;
                // Datum vanaf
                case 1032:
                    innerHTML += `<layer-info-filter-settings-date data-label="Vanaf" data-key="` + key + `"></layer-info-filter-settings-date>`
                    break;
                // Datum tot
                case 1033:
                    innerHTML += `<layer-info-filter-settings-date data-label="Tot" data-key="` + key + `"></layer-info-filter-settings-date>`
                    break;
            }
        }

        template.innerHTML = innerHTML

        initWebComponent(this, template)
    }
}
